import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { AuthProvider } from './components/AuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';

const Home = lazy(() => import('./pages/Home'));
const Place = lazy(() => import('./pages/Place'));
const Profile = lazy(() => import('./pages/Profile'));
const Search = lazy(() => import('./pages/Search'));
const Shared = lazy(() => import('./pages/Shared'));
const MyPlaces = lazy(() => import('./pages/MyPlaces'));

function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="w-8 h-8 border-4 border-gold-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-dark-900">
            <Navbar />
            <main className="container mx-auto px-4 py-8">
              <ErrorBoundary>
                <Suspense fallback={<PageLoader />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/place/:id" element={
                      <PrivateRoute>
                        <Place />
                      </PrivateRoute>
                    } />
                    <Route path="/profile" element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    } />
                    <Route path="/search" element={
                      <PrivateRoute>
                        <Search />
                      </PrivateRoute>
                    } />
                    <Route path="/shared" element={
                      <PrivateRoute>
                        <Shared />
                      </PrivateRoute>
                    } />
                    <Route path="/my-places" element={
                      <PrivateRoute>
                        <MyPlaces />
                      </PrivateRoute>
                    } />
                  </Routes>
                </Suspense>
              </ErrorBoundary>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;